import React from "react";
import Modal from "../../Modal";
import AliaseSubIdHistory from "./AliaseSubIdHistory";

const AliaseSubIdHistoryModal = ({ open, setOpen, diData, loading }) => {
  return (
    <Modal
      title="History - Sub Identities & Aliases"
      open={open}
      setOpen={setOpen}
      okText=""
      canelText=""
      type="subid-alias-history"
      noActions={true}
    >
      <AliaseSubIdHistory diData={diData} loading={loading} />
    </Modal>
  );
};

export default AliaseSubIdHistoryModal;
